import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgClass} from '@angular/common';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {RtChoice} from '../../../rt-inputs/symbols/rt-inputs-types.symbols';

@Component({
  selector: 'app-dashboard-study-viewer-controls-select',
  templateUrl: './dashboard-study-viewer-controls-select.component.html',
  styleUrls: ['./dashboard-study-viewer-controls-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule, NgClass, MatMenuTrigger, MatMenu, MatMenuItem],
})
export class DashboardStudyViewerControlsSelectComponent<T> {
  @Input({required: true}) viewName: string;
  @Input({required: true}) choicesControl: FormControl<T>;
  @Input({required: true}) choices: RtChoice<T, string>[];

  /**
   * Selects a choice from the dropdown menu.
   */
  public selectChoice(choiceElement: T): void {
    this.choicesControl.setValue(choiceElement);
  }
}
